import React, { useContext, createContext } from "react";
import _ from "lodash";

import {
  GetMobileSortPropsResult,
  GetSearchInputPropsResult,
  HeaderContextInterface,
  HeaderContextProviderProps,
} from "./headerContextProvider.types";

const HeaderContext = createContext<HeaderContextInterface>({
  getSearchInputProps: () => ({
    globalFilter: "",
    setGlobalFilter: _.noop,
    ariaLabelMessage: "",
  }),
  getMobileSortProps: () => ({
    allColumns: [],
    toggleSortBy: _.noop,
    sortBy: [],
  }),
});

export const HeaderContextProvider = ({
  state,
  setGlobalFilter,
  allColumns,
  toggleSortBy,
  ariaLabelMessage,
  children,
}: HeaderContextProviderProps) => {
  const getSearchInputProps = (): GetSearchInputPropsResult => ({
    globalFilter: state.globalFilter,
    setGlobalFilter,
    ariaLabelMessage,
  });

  const getMobileSortProps = (): GetMobileSortPropsResult => ({
    allColumns,
    toggleSortBy,
    sortBy: state.sortBy,
  });

  return (
    <HeaderContext.Provider value={{ getSearchInputProps, getMobileSortProps }}>
      {children}
    </HeaderContext.Provider>
  );
};

export const useHeaderTableContext = () => useContext(HeaderContext);
